import { render, staticRenderFns } from "./LinkInput.vue?vue&type=template&id=4dd4fe50&scoped=true"
import script from "./LinkInput.vue?vue&type=script&lang=js"
export * from "./LinkInput.vue?vue&type=script&lang=js"
import style0 from "./LinkInput.vue?vue&type=style&index=0&id=4dd4fe50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd4fe50",
  null
  
)

export default component.exports